import { render } from "./PosOrderShowComponent.vue?vue&type=template&id=ad6d7c16"
import script from "./PosOrderShowComponent.vue?vue&type=script&lang=js"
export * from "./PosOrderShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/posOrders/PosOrderShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad6d7c16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad6d7c16', __exports__)) {
    api.reload('ad6d7c16', __exports__)
  }
  
  module.hot.accept("./PosOrderShowComponent.vue?vue&type=template&id=ad6d7c16", () => {
    api.rerender('ad6d7c16', render)
  })

}


export default __exports__